module.exports = __webpack_public_path__ + "media/images/top/flow02-136125abd58fef83dc5c5a1840eb67b1.jpg";